import React from "react";
import ReactEcharts from "echarts-for-react";

const SalesTrendsWidget: React.FC = () => {
  const option = {
    backgroundColor: "transparent",
    tooltip: {
      trigger: "axis", // 触发方式为坐标轴触发
      axisPointer: {
        type: "line",
        label: {
          backgroundColor: "#6a7985", // 辅助线标签背景色
        },
      },
    },
    xAxis: {
      type: "category",
      data: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
      axisLabel: {
        color: "#fff",
        fontSize: 12,
        rotate: 0,       // 可选旋转角度，避免重叠
        overflow: "truncate", // 超出部分显示为...
      },
      axisLine: { lineStyle: { color: "#4dc9f6" } },
    },
    yAxis: {
      type: "value",
      axisLabel: { color: "#fff", fontSize: 12 },
      splitLine: { lineStyle: { color: "rgba(255,255,255,0.1)" } },
    },
    series: [
      {
        data: [2000, 15000, 28000, 22000, 12000, 30000],
        type: "line",
        smooth: true,
        symbol: "circle",
        symbolSize: 8,
        lineStyle: { color: "#4dc9f6", width: 3 },
        itemStyle: { color: "#4dc9f6" },
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: "rgba(77,201,246,0.4)" },
              { offset: 1, color: "rgba(77,201,246,0)" },
            ],
          },
        },
        label: {
          show: false, // 默认不显示标签
        },
        // emphasis: {
        //   label: {
        //     show: true, // 鼠标悬停时显示标签
        //     position: "top", // 标签显示在点的上方
        //     color: "#fff", // 标签颜色
        //     fontSize: 12, // 标签字体大小
        //   },
        // },
      },
    ],
    grid: {
      left: "4%",   // 留更多空间给纵坐标
      right: "5%",
      top: "10%",
      bottom: "10%", // 留更多空间给横坐标
      containLabel: true, // 自动考虑轴标签
    },
  };

  return (
    <div
      className="card"
      style={{
        width: "100%",
        height: "100%",
        padding: 10,
        borderRadius: "8px",
        backgroundColor: "#142d4c",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
      }}
    >
      <h2 style={{ color: "white", fontSize: "1.5vw" }}>Sales Trends</h2>
      <ReactEcharts
        option={option}
        style={{ flex: 1, width: "100%", height: "100%" }}
        notMerge={true}
        lazyUpdate={true}
        opts={{ renderer: "canvas" }}
      />
    </div>
  );
};

export default SalesTrendsWidget;
